module.exports = __webpack_public_path__ + "img/NATA_Visual_1.c24a217f.png";